export default "__VITE_ASSET__BNM4Uhke__"